import React from "react";
import { jsPDF } from "jspdf";
import styles from "./Row.module.sass";
import cn from "classnames";
import Icon from "../../../../../../../components/Icon";
import moment from "moment";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import ReactDOM from "react-dom";

const Row = ({ 
  item, 
  activeTable, 
  activeId, 
  setActiveId,
  value,
  onChange,
  onRowClick
}) => {
  const handleDownload = async (event) => {
    event.stopPropagation();
    
    const hiddenDiv = document.createElement("div");
    hiddenDiv.style.position = "absolute";
    hiddenDiv.style.top = "-10000px";
    document.body.appendChild(hiddenDiv);

    const barcodeElement = document.createElement("div");
    hiddenDiv.appendChild(barcodeElement);

    const barcode = <Barcode value={item.barcode} />;
    ReactDOM.render(barcode, barcodeElement);

    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(barcodeElement);
    const barcodeImage = canvas.toDataURL("image/png");

  
    const pdf = new jsPDF();
    pdf.addImage(barcodeImage, "PNG", 30, 50, 150, 70);
    pdf.save(`barcode_${item.barcode}.pdf`);

    document.body.removeChild(hiddenDiv);
  };

  return (
    <div
      className={cn(
        styles.row,
        { [styles.selected]: activeId === item.id },
        { [styles.active]: activeTable }
      )}
      onClick={() => {
        setActiveId(item.id);
        onRowClick();
      }}
    >
      <div className={styles.col}>
        <div className={styles.email}>{item.barcode}</div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>{item.tag_name}</div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>
          {moment(item.created_at).format("DD MMM YYYY")}
        </div>
      </div>
      <div className={styles.col}>
        <div onClick={handleDownload}>
          <Icon name="download" size="24" />
        </div>
      </div>
    </div>
  );
};

export default Row;